module.exports = __webpack_public_path__ + "img/Mask Group 2886@2x.0a8d3e1a.png";